import styled, { css } from 'styled-components';
import { MediaQuery, AspectRatio, ImageRendition, isAspectRatio, isMediaQuery } from '../../utils/ImageUtils';

function getAspectRatio(aspectRatio: AspectRatio): string {
  switch (aspectRatio) {
    case AspectRatio.CLASSIC_HOR:
      return '3 / 2';
    case AspectRatio.WIDE_HOR:
      return '16 / 9';
    case AspectRatio.STANDARD_HOR:
      return '2 / 1';
    case AspectRatio.FEATURE_HOR:
      return '5 / 2';
    case AspectRatio.PANO_HOR:
      return '3 / 1';
    case AspectRatio.CLASSIC_VER:
      return '2 / 3';
    case AspectRatio.WIDE_VER:
      return '9 / 16';
    case AspectRatio.STANDARD_VER:
      return '1 / 2';
    case AspectRatio.FEATURE_VER:
      return '2 / 5';
    case AspectRatio.PANO_VER:
      return '1 / 3';
    case AspectRatio.SQUARE:
    default:
      return '1 / 1';
  }
}

function outputAspectRatioStyle(mediaQuery: MediaQuery, aspectRatio: AspectRatio) {
  return css`
    @media ${mediaQuery} {
      aspect-ratio: ${getAspectRatio(aspectRatio)};
    }
  `;
}

export const AImagePicture = styled.picture<{ renditions: ImageRendition[] }>`
  display: block;
  width: 100%;
  overflow: hidden;

  ${({ renditions }) => {
    const renditionItems = renditions.map(({ media, aspectRatio }) =>
      isMediaQuery(media) && isAspectRatio(aspectRatio)
        ? outputAspectRatioStyle(media as MediaQuery, aspectRatio as AspectRatio)
        : ''
    );
    return css`
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        ${renditionItems}
      }
    `;
  }}
`;
